export const sxStyle = {
  companyValuesContainer: {
    padding: { xs: '40px 25px 0px 20px', sm: '40px 0px 0px 200px' },
  },
  companyText: {
    marginRight: { xs: 0, sm: '30px' },
    paddingBottom: '30px',
    textAlign: 'justify',
  },
  backroundMobile: {
    background: '#E5E5E5',
    paddingBottom: { xs: '20px', sm: '30px' },
  },
  womanImgMobile: {
    display: { xs: 'flex', sm: 'none' },
    padding: { xs: '20px', sm: 0 },
  },
  womanImgDesktop: {
    display: { xs: 'none', sm: 'flex' },
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  valuesSpaceBotom: {
    padding: { xs: 0, sm: '5px 20px 40px 80px' },
    display: { xs: 'none', sm: 'block' },
  },
  goalsSectionContainer: {
    marginTop: '30px',
    padding: {
      xs: '0px 20px 0px 0px',
      sm: '0px 200px 100px 200px',
      '1500px': '0px 200px 200px 200px',
    },
  },
  menImgContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    padding: { xs: '20px', sm: 0 },
  },
  menImg: {
    borderRadius: 5,
    width: '100%',
    height: '100%',
    maxHeight: '450px',
    maxWidth: '400px',
  },
  goalsContainer: {
    padding: { xs: '20px', sm: '20px 30px 0px 0px' },
    maxWidth: '600px',
  },
  diamond: theme => ({
    width: '10px',
    height: '10px',
    background: theme.tertiary,
    borderRadius: '50%',
    marginTop: '8px',
  }),
  goalsItemContainer: {
    flexWrap: 'nowrap',
  },
  goalsText: {
    textAlign: 'justify',
    paddingBottom: '20px',
    paddingLeft: '14px',
  },
};
